import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { formatDuration } from "./format-duration";

export const LoginHistoryModal = ({ data, total, coach, type }) => {
  const rows = [...data]
    .filter(d => Math.round(moment.duration(d.totalTime).asMinutes()) !== 0)
    .sort((a, b) => new Date(a.start) - new Date(b.start));

  // Include the date when sessions span multiple days so cross-midnight times are distinguishable
  const spansDays = rows.some(
    d =>
      !moment(d.start).isSame(rows[0].start, "day") ||
      (d.end != null && !moment(d.end).isSame(rows[0].start, "day"))
  );
  const timeFormat = spansDays ? "M/D h:mm A" : "h:mm A";

  return (
    <div className="historyContainer">
      <div className="historyTitle">
        Viewing {type} times for {coach}
      </div>
      <div className="historyRow historyHeader">
        <div>Start</div>
        <div>End</div>
        <div>Total</div>
      </div>
      {rows.map((d, index) => (
        <div
          key={d.start}
          className={
            (index + 1) % 2 === 0 ? "historyRow" : "historyRow historyRowStriped"
          }
        >
          <div>{moment(d.start).format(timeFormat)}</div>
          <div>
            {d.end == null ? (
              <span className="currentPill">Current</span>
            ) : (
              moment(d.end).format(timeFormat)
            )}
          </div>
          <div>{formatDuration(d.totalTime)}</div>
        </div>
      ))}
      <div className="historyRow historyTotal">
        <div>Total:</div>
        <div className="totalValue">{formatDuration(total)}</div>
      </div>
    </div>
  );
};

LoginHistoryModal.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  total: PropTypes.string,
  coach: PropTypes.string,
  type: PropTypes.string
};
